import { render, staticRenderFns } from "./SupplierAgentDetails.vue?vue&type=template&id=f1496316&scoped=true&"
import script from "./SupplierAgentDetails.vue?vue&type=script&lang=js&"
export * from "./SupplierAgentDetails.vue?vue&type=script&lang=js&"
import style0 from "./SupplierAgentDetails.vue?vue&type=style&index=0&id=f1496316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1496316",
  null
  
)

export default component.exports